import { defineComponent as _defineComponent } from 'vue'
import { listProps } from './list';
import spaceFormat from '../../utils/spaceFormat';
import columnsFormat from '../../utils/columnsFormat';


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  props: listProps,
  setup(__props) {

const props = __props



return { __sfc: true,props, spaceFormat, columnsFormat }
}

})